export interface FAQ {
  id: number;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 1,
    question: "91网是什么类型的平台？",
    answer: "91网是一个综合性的资源整合与服务平台，致力于为用户提供涵盖设计素材、办公模板、技术文档、行业报告等多领域的优质资源。平台通过分类导航、智能推荐等方式，帮助用户快速找到所需的资源和服务，并提供会员专属权益以提升使用体验。",
  },
  {
    id: 2,
    question: "如何注册成为91网会员？",
    answer: "注册91网会员非常简单。您只需点击页面右上角的「注册」按钮，填写手机号码或邮箱地址，设置登录密码，并通过短信或邮箱验证码完成验证即可。注册过程不到1分钟，注册成功后即可享受91网的基础服务。如需更多权益，可以升级VIP会员。",
  },
  {
    id: 3,
    question: "VIP会员有哪些权益？",
    answer: "91网VIP会员享有六大核心权益：1）海量资源无限畅享；2）高速下载优先通道；3）7×24小时专属技术支持；4）每日个性化资源推送；5）VIP会员专属社群；6）商业使用授权保障。不同等级的会员在下载配额和专属服务上有所差异。",
  },
  {
    id: 4,
    question: "免费用户可以使用哪些功能？",
    answer: "免费用户同样可以使用91网的核心功能，包括：浏览和搜索资源库、查看资源详情和用户评价、参与社区讨论。但免费用户每日下载次数有限制，下载速度为标准速度，部分高级资源需要VIP会员才能访问。",
  },
  {
    id: 5,
    question: "91网上的资源是否可以商用？",
    answer: "VIP会员下载的资源均附赠商业使用授权，可用于商业项目。免费用户下载的资源仅限个人学习和非商业用途使用。建议在使用前仔细查看每份资源的授权说明，确保合规使用。如有特殊商用需求，可联系客服获取定制授权方案。",
  },
  {
    id: 6,
    question: "如何下载91网上的资源？",
    answer: "在资源详情页面找到需要下载的资源，点击「立即下载」按钮。如果是会员专享资源，系统会自动检查您的会员状态。下载支持单文件和批量打包两种方式。建议使用Chrome或Edge浏览器以获得最佳下载体验。如遇到下载问题，可联系技术支持获取帮助。",
  },
  {
    id: 7,
    question: "资源下载后打不开怎么办？",
    answer: "如果下载的资源无法正常打开，请先检查：1）文件是否完整下载（核对文件大小）；2）是否安装了对应的打开软件；3）文件格式是否与软件版本兼容。如以上检查均正常但仍无法打开，请联系客服并提供资源编号，我们将协助您解决问题。",
  },
  {
    id: 8,
    question: "会员到期后已下载的资源还能使用吗？",
    answer: "可以。会员到期后，您之前已下载到本地的资源不会失效，可以继续使用。但您将无法下载新的会员专享资源，下载速度也会恢复为标准速度。随时可以续费恢复会员资格，续费后所有权益立即恢复。",
  },
  {
    id: 9,
    question: "91网支持哪些支付方式？",
    answer: "91网目前支持多种支付方式，包括：微信支付、支付宝、银联在线支付以及Apple Pay。支付过程采用银行级加密技术，确保您的资金安全。支付成功后会员权益即时生效，无需等待。",
  },
  {
    id: 10,
    question: "如何联系91网客服？",
    answer: "您可以通过以下方式联系91网客服团队：1）在线客服：点击网站右下角的客服图标进行实时对话；2）客服电话：400-888-9191（工作日9:00-18:00）；3）客服邮箱：service@91wang.com；4）微信公众号：搜索「91网服务」关注后留言。我们承诺在工作时间内30分钟内响应。",
  },
];